import { createAction, createReducer, createSelector } from "@reduxjs/toolkit";
import { presetStateSelector } from "../utils/state.js";
import { replaceById } from "../utils/immer.js";
const initialState = {
    markers: [],
    selectedMarker: null,
};
export const selectMarker = createAction("markers/selectMarker");
export const updateMarker = createAction("markers/updateMarker");
export const markersReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(selectMarker, (state, { payload }) => {
        state.selectedMarker = payload;
    })
        .addCase(updateMarker, (state, { payload }) => {
        const { selectedMarker } = state;
        const currentMarker = state.markers.find(marker => marker.id === selectedMarker);
        if (currentMarker && selectedMarker) {
            replaceById(state.markers, selectedMarker, {
                ...currentMarker,
                ...payload,
            });
        }
    });
});
export const getMarkersState = createSelector([presetStateSelector], present => present.markers);
export const getMarkers = createSelector([getMarkersState], state => state.markers);
export const getSelectedMarkerId = createSelector([getMarkersState], state => state.selectedMarker);
export const getSelectedMarker = createSelector([getMarkers, getSelectedMarkerId], (markers, id) => markers.find(marker => marker.id === id));
